export const isIframe = () => {
  return window.self !== window.top;
};
